import React, { useState, useEffect, useRef } from 'react';
import Grid from '@mui/material/Grid2';
import 'leaflet/dist/leaflet.css';
import { Stack, Box, Typography } from '@mui/material';
import Bar from '../components/bar';
import RiskAnalysisSelectMenus from '../components/risk_analysis_select_menus';
import MapRisk from '../components/risk_analysis_map';
import CommonCard from '../item/common_card';
import VerticalBar from '../components/vertical_bar'
import Proggress from '../item/progress'
import HeaderSub from '../item/header_sub'
import ColorCard from '../item/color_card'
import Line from '../components/risk_analysis_line'
import { useLocation } from 'react-router-dom'
import { useDataFromS3 } from '../hooks/useDataFromS3';
import {
    RISK_LEVEL_POINT,
    BSN_RISK_LEVEL_POINT,
    RAIN_H1_LEVEL_POINT,
    RAIN_H24_LEVEL_POINT,
    RAIN_H48_LEVEL_POINT,
    RISK_COLOR,
    TANK_LEVEL_POINT
} from '../const/color'
import '../style/legend_risk.css';
import { TypographyLeftMenu, TypographyTitle, TypographyBold14px } from '../style/typography'
import { BoxFlexEndTop, BoxCenterEnd } from '../style/box'
import { setRainColor, setRainFontColor, setRiskColor, setSrRiskColor } from '../func/color';
import { getTimeAry, getAllByCode } from '../func/util'
import {
    getRankWithAreaInfo, getRankWithBsnInfo,
    convertAreaDataFromMshDataByKeyName,
    findContainingFeature, convert3dMshDataFrom4dMshData,
    getStrDateTimePath, getBsnInfo, findNearestLineFeature
} from '../func/risk_analysis_utils'
import { GRID_RANK } from '../const/grid'
import { RAIN_Y_4LINES, RISK_Y_4LINES, SOIL_Y_4LINES } from '../const/annotations'
import { RISK_ANALYSIS_LAYER_KEY } from '../const/map_config'
import choropleth_area from '../data/area.json';
import choropleth_msh from '../data/msh.json';
import choropleth_flood from '../data/flood.json';
import choropleth_bsn from '../data/bsn.json';

const RiskAnalysis = (props) => {
    const [dateArray, setDateArray] = useState(null);
    const [addressWithRiver, setAddressWithRiver] = useState('-');
    const [mapData, setMapData] = useState(null);
    const [chartData, setChartData] = useState(null);
    const [rankData, setRankData] = useState(null);
    const [colorChartData, setColorChartData] = useState(null);
    const [landslideH1ValAry, setLandslideH1ValAry] = useState(null);
    const [landslideH24ValAry, setLandslideH24ValAry] = useState(null);
    const [landslideH48ValAry, setLandslideH48ValAry] = useState(null);
    const [landslideRiskValAry, setLandslideRiskValAry] = useState(null);
    const [bsnH1ValAry, setBsnH1ValAry] = useState(null);
    const [bsnH24ValAry, setBsnH24ValAry] = useState(null);
    const [bsnH48ValAry, setBsnH48ValAry] = useState(null);
    const [bsnOfValAry, setBsnOfValAry] = useState(null);
    const [barOrLineAnnotatios, setBarOrLineAnnotatios] = useState(RAIN_Y_4LINES(RAIN_H1_LEVEL_POINT));
    const [barOrLineLimitVal, setBarOrLineLimitVal] = useState(RAIN_H1_LEVEL_POINT + 10);
    const [levelPoint, setLevelPoint] = useState(RAIN_H1_LEVEL_POINT);
    const [shouldFetchMain, setShouldFetchMain] = useState(false);
    // 選択している緯度経度
    const [currentLngLat, setCurrentLngLat] = useState(null)
    // 選択された緯度経度のポイントが選択市町村内に存在しない場合
    // ランキングトップの緯度経度にポイントを移すかどうかのフラグ
    const [shouldSelectRankTop, setShouldSelectRankTop] = useState(true)
    // 選択している時間のインデックス
    const [chooseNum, setChooseNum] = useState(12)

    const prevDatetimeRef = useRef(null);
    const location = useLocation();
    
    const {
        data: datetimeLatest,
        loading: datetimeLatestLoading,
        error: datetimeLatestError,
    } = useDataFromS3(`api/get_datetime_latest`);

    // サーバーの最終更新日時が変更されているか判定
    useEffect(() => {
        if (datetimeLatest && JSON.stringify(datetimeLatest) !== JSON.stringify(prevDatetimeRef.current)) {
            prevDatetimeRef.current = datetimeLatest;
            setShouldFetchMain(true); // dataが変わったらメインデータを取得
        } else {
            setShouldFetchMain(false); // dataが変わってないならメインデータを取得しない
        }
    }, [datetimeLatest]);

    let msh_rain_url = null
    let bsn_rain_url = null
    let landslide_msh_url = null

    if (shouldFetchMain) {
        msh_rain_url = `api/get_msh_max_h1_h24_h48`
        bsn_rain_url = `api/get_bsn_of`
        landslide_msh_url = `api/get_risk`
    }
    // 雨量データを取得
    const {
        data: mshRainData,
        loading: mshRainLoading,
        error: mshRainError,
    } = useDataFromS3(msh_rain_url);

    // 土砂災害リスクを取得
    const {
        data: mshLandslideData,
        loading: mshLandslideLoading,
        error: mshLandslideError,
    } = useDataFromS3(landslide_msh_url);

    // 流域平均雨量データを取得
    const {
        data: bsnRainData,
        loading: bsnRainLoading,
        error: bsnRainError,
    } = useDataFromS3(bsn_rain_url);

    useEffect(() => {
        prevDatetimeRef.current = null
    }, [location.pathname])

    const setColor = (val) => {
        switch (props.riskAnalysisLayer.category) {
            case RISK_ANALYSIS_LAYER_KEY.MSH_H1:
            case RISK_ANALYSIS_LAYER_KEY.BSN_H1:
                return setRainColor(RAIN_H1_LEVEL_POINT, val);
            case RISK_ANALYSIS_LAYER_KEY.MSH_H24:
            case RISK_ANALYSIS_LAYER_KEY.BSN_H24:
                return setRainColor(RAIN_H24_LEVEL_POINT, val);
            case RISK_ANALYSIS_LAYER_KEY.MSH_H48:
            case RISK_ANALYSIS_LAYER_KEY.BSN_H48:
                return setRainColor(RAIN_H48_LEVEL_POINT, val);
            case RISK_ANALYSIS_LAYER_KEY.MSH_RISK:
                return setRiskColor(RISK_LEVEL_POINT, val);
            case RISK_ANALYSIS_LAYER_KEY.MSH_SOIL:
                return setSrRiskColor(val)?.color
            case RISK_ANALYSIS_LAYER_KEY.BSN_OF:
                return setRiskColor(BSN_RISK_LEVEL_POINT, val);
            default:
                return setRainColor(RAIN_H1_LEVEL_POINT, val);
        }
    };

    const getRankData = (data, isOver, sliderValueRef, getLabelValue, getYValue) => {
        // dataを配列としてrankDataに入れる
        const rankData = Array.isArray(data) ? [...data] : [];
        rankData.sort((a, b) => {
            if (a.max_soil !== b.max_soil) return a.max_soil - b.max_soil; 
            if (a.max !== b.max) return a.max - b.max;                     
            return b.area_code - a.area_code;                              
        });

        // sliderValueに応じてリスクの最大値を並べ替え
        let series_ary = []
        let category_ary = []
        if (isOver) {
            // for (let i = sliderValue[1]; i > sliderValue[0] - 1; i--) {
            for (let i = sliderValueRef.current[1]; i > sliderValueRef.current[0] - 1; i--) {
                if (rankData.length > i) {
                    let str_time = ''
                    let time_index = 0
                    if (rankData[i].index_Val) {
                        str_time = `　${dateArray[rankData[i].index_Val]}`
                        time_index = rankData[i].index_Val
                    }
                    series_ary.push({
                        x: '',
                        y: rankData[i].max,
                        custom: {
                            area_name: rankData[i].area_name,
                            area_code: rankData[i].area_code,
                            area_lng: rankData[i].area_lng,
                            area_lat: rankData[i].area_lat,
                            str_time: str_time,
                            time_index: time_index,
                            soil: rankData[i].max_soil,
                        }
                    })
                    category_ary.push(rankData[i].area_name)
                }
            }
        } else {
            rankData.map(item => {
                let str_time = ''
                let time_index = 0
                if (item.index_Val) {
                    str_time = `　(${dateArray[item.index_Val]})`
                    time_index = item.index_Val

                }
                series_ary.push({
                    x: '',
                    y: item.max,
                    custom: {
                        area_name: item.area_name,
                        area_code: item.area_code,
                        area_lng: item.area_lng,
                        area_lat: item.area_lat,
                        str_time: str_time,
                        time_index: time_index,
                        soil: item.max_soil,
                    }
                })
                category_ary.push(item.area_name)
            })
        }
        return { rankData, series_ary, category_ary };
    }

    // ランキングクリック時の動作
    const verticalBarClickEvent = (clickedItem) => {
        setCurrentLngLat([clickedItem.custom.area_lng, clickedItem.custom.area_lat])
        setChooseNum(clickedItem.custom.time_index)
    }

    // ランキングのカラー
    const getRainColor = (value, series, seriesIndex, dataPointIndex, w) => {
        return setRainColor(levelPoint, value)
    }

    // ランキングのカラー
    const getRiskColor = (value, series, seriesIndex, dataPointIndex, w) => {
        if(props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_SOIL) {
            const valueSoilIndexLever = series[seriesIndex]?.data[dataPointIndex]?.custom?.soil;
            return setSrRiskColor(valueSoilIndexLever)?.color
        }else{
            return setRiskColor(levelPoint, value)
        }
    }

    // ランキングのフォーマット
    const getFormat = (val, opts) => {
        const customData = opts.w.config.series[0].data[opts.dataPointIndex].custom;
        return `${val} ${customData.str_time}`;
    }

    // ランキングのラベルフォーマット
    const getLabelFormat = (value) => {
        let str = String(value);
        // 8文字以上は省略
        if (str.length >= 8) {
            return str = str.slice(0, 3) + '…' + str.slice(-4);
        }
        return '　'.repeat(8 - str.length) + str;
    }

    // ランキングのX軸ツールチップフォーマット
    const tooltipFormatX = (opts) => {
        return opts.w.config.series[opts.seriesIndex].data[opts.dataPointIndex].custom.area_name;
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatY = (val) => {
        return String(val);
    }

    // ランキングのY軸ツールチップフォーマット
    const tooltipFormatCustom = (opts, areaNameAry, areaRiverNameAry) => {
        const label = opts.w.globals.labels[opts.dataPointIndex]; // y軸ラベル
        const value = opts.series[opts.seriesIndex][opts.dataPointIndex]; // 値
        const seriesName = opts.w.globals.seriesNames[opts.seriesIndex];

        return `<div style="padding: 4px 8px; font-size: 12px;">
                ${label} ${seriesName}: ${value}
                </div>`;
    }

    // 地図上のピンの緯度経度を取得
    const getCurrentLngLat = (rankData, masterMshFeatures) => {
        if (!rankData || rankData.length === 0) {
            return currentLngLat;
        }

        // ランキングトップの緯度経度
        const topLngLat = [rankData[0].area_lng, rankData[0].area_lat];
        let lng_lat = null
        if (currentLngLat === null) {
            // 地図上でピンが未指定の場合
            // ランキングトップに該当するメッシュでピンを打ち直す
            lng_lat = topLngLat;
            setCurrentLngLat(topLngLat);
        } else {
            lng_lat = currentLngLat
            const current_msh_code = findContainingFeature(masterMshFeatures, currentLngLat)
            if (!current_msh_code && shouldSelectRankTop) {
                // 地図上でピンを打っているメッシュが選択市町村内に存在しない場合
                // ランキングトップに該当するメッシュでピンを打ち直す
                if (currentLngLat[0] !== topLngLat[0] || currentLngLat[1] !== topLngLat[1]) {
                    setCurrentLngLat(topLngLat);
                }
            }
        }
        setShouldSelectRankTop(true)
        return lng_lat;
    }

    const getCurrentBsnFromFlood = (current_msh_code) => {
        // currentLngLat が　nullではない場合　currentLngLat　がどの河川に属するか　features_bsn　から探すべきかも
        // それで見つからなければfloodデータ取得とすべきかも
        const features_flood = choropleth_flood.features
        const mastreFloodFeatures = features_flood.find(f => f.properties.id === current_msh_code);
        // bsnデータの properties.id を配列で取得(これが対象のbsnコード)
        if (mastreFloodFeatures) {
            const raw = mastreFloodFeatures.properties?.bsn_code;
            if (!raw) return [];

            const bsn_code = raw
                .split(',')
                .map(str => str.trim())     // 前後の空白を除去
                .filter(str => str !== '')  // 空文字を除外
                .map(Number)                // 数値に変換
                .filter(num => !isNaN(num)); // NaN除外（変換失敗対策）

            return bsn_code[0]
        }
        return null;
    }

    // データ整備用のパラメータを取得
    const getParamsMsh = (keyAry, keyName = '') => {
        const features_area = choropleth_area.features
        const features_msh = choropleth_msh.features
        const features_bsn = choropleth_bsn.features
        
        const keySet = new Set(keyAry.map(String));
        // メッシュデータ取得
        const masterMshFeatures = features_msh.filter(f =>
            keySet.has(String(f.properties[keyName]))
        );

        // メッシュデータの properties.id を配列で取得(これが対象のメッシュコード)
        const msh_code_ary = masterMshFeatures.map(feature => feature.properties.id);

        // bsnデータ取得
        const masterBsnFeatures = features_bsn.filter(f =>
            keySet.has(String(f.properties[keyName]))
        );
        // bsnデータの properties.id を配列で取得(これが対象のbsnコード)
        const bsn_code_ary = masterBsnFeatures.map(feature => feature.properties.bsn_code);

        // メッシュデータの properties.area_code を配列で取得(これが対象の字コード)
        const area_code_ary = [...new Set(masterMshFeatures.map(feature => feature.properties.area_code))];
        // 字のマスターデータ取得
        const masterAreaFeatures = features_area.filter(f =>
            area_code_ary.includes(f.properties.id)
        );

        return {
            msh_code_ary, area_code_ary, bsn_code_ary,
            masterMshFeatures, masterAreaFeatures, masterBsnFeatures,
        };
    }

    const setColorSortRankData = (rankData, data) => {
        rankData.forEach((item) => {
            item.max_soil = getChoosePointData(data, 'soil_index_level',item.msh_code)[item.index_Val] ?? null;
        });
        rankData.sort((a, b) => {
            if (a.max_soil !== b.max_soil) return b.max_soil - a.max_soil; 
            if (a.max !== b.max) return b.max - a.max;                     
            return a.area_code - b.area_code;                              
        });
        return rankData; 
    }

    // 土砂の地図、チャート用のデータを取得
    const getData = (data, masterMshFeatures, masterAreaFeatures, keyName = '', isRisk = false) => {
        // 3次メッシュに変換したデータを取得
        const map_data = convert3dMshDataFrom4dMshData(data, keyName);

        // Bar、Lineチャート用のデータ、被災リスクの場合はこれを地図データとして渡す
        const targetAry = data.map(item => ({
            code: item.code,
            val: item[keyName], // ← targetKey で指定したキーの値を val に固定して格納
            soil: keyName === 'dc_tank_of_num' ? item['soil_index_level'] : null,
        }));

        // ランキングチャート用に字コードをキーにしたデータを作成
        const areaData = convertAreaDataFromMshDataByKeyName(masterMshFeatures, targetAry)

        // ランキング用のデータ
        let rankData = getRankWithAreaInfo(masterAreaFeatures, masterMshFeatures, areaData, 200)
        if(keyName === 'dc_tank_of_num'){
            rankData = setColorSortRankData(rankData, data);
        }

        // 地図上のピンの緯度経度を取得
        const lngLat = getCurrentLngLat(rankData, masterMshFeatures)

        const commonData = getCommonData(lngLat)

        // Bar、Lineチャート用のデータ
        const targetItem = targetAry.find(item => item.code === commonData.currentMshCode);
        let targetItemVal = [];
        let colorChartVal = [];
        if (targetItem) {
            targetItemVal = targetItem.val;
            colorChartVal = targetItem?.soil;
        }
        return {
            msh_code: commonData.currentMshCode,
            bsn_code: commonData.currentBsnCode,
            addressWithRiver: commonData.addressWithRiver,
            map_data: isRisk ? targetAry : map_data,
            chart_data: targetItemVal,
            color_chart_data: colorChartVal,
            rank_data: rankData,
        };
    }

    const getBsnData = (data, masterInfo, keyName, mastreBsnFeatures) => {
        // 地図レイヤー色分け用のデータ
        const map_data = data.map(item => ({
            code: item.code,
            val: item[keyName], // ← targetKey で指定したキーの値を val に固定して格納
        }));

        // １時間雨量のランキング用のデータ
        const rankData = getRankWithBsnInfo(masterInfo, map_data, 200)

        const currentLngLat = getCurrentLngLat(rankData, mastreBsnFeatures)

        const commonData = getCommonData(currentLngLat)

        // Bar、Lineチャート用のデータ
        const targetItem = map_data.find(item => item.code === commonData.currentBsnCode);
        let targetItemVal = []
        if (targetItem) {
            targetItemVal = targetItem.val
        }

        return {
            msh_code: commonData.currentMshCode,
            bsn_code: commonData.currentBsnCode,
            addressWithRiver: commonData.addressWithRiver,
            map_data: map_data,
            chart_data: targetItemVal,
            rank_data: rankData,
        };
    }

    const getCommonData = (lng_lat) => {
        const features_msh = choropleth_msh.features
        const features_bsn = choropleth_bsn.features
        // ここに来る時点で currentLngLat がnullであることはない
        // 選択市町村ないに current_msh_code がないケースはある
        const currentMshCode = findContainingFeature(features_msh, lng_lat)
        // まずはbsnデータから BsnCode を探す
        let currentBsnCode = findNearestLineFeature(features_bsn, lng_lat)
        // 見つからなければfloodデータからBsnCode を探す
        if (currentBsnCode === null) {
            currentBsnCode = getCurrentBsnFromFlood(currentMshCode)
        }
        // 選択メッシュの住所を取得
        const strAddress = features_msh.find(f =>
            currentMshCode === f.properties.id)?.properties.name ?? 'ー';

        // 選択メッシュの河川名を取得
        const strRiverName = features_bsn.find(f =>
            currentBsnCode === f.properties.bsn_code)?.properties.txt_river_name_show ?? 'ー';
        const addressWithRiver = `住所：${strAddress}　河川名：${strRiverName}`

        return { currentMshCode, currentBsnCode, addressWithRiver }

    }

    // 画面下部のチャートの基準線を取得
    const getConsts = (func, POINT, isRisk) => {
        return {
            point: POINT,
            bar_or_line_annotatios: func(POINT),
            bar_or_line_limit_val: isRisk ? POINT.LEVEL_4 + 10 : POINT.LEVEL_7 + 10,
        };
    }
    // 画面右下の情報を取得
    const getChoosePointData = (data, keyName, currentMshCode) => {
        const targetVal = data.find(item => item.code === currentMshCode)?.[keyName];
        return Array.isArray(targetVal) ? targetVal : null;
    }

    const get4LinesSoil = (masterMshFeatures, currentMshCode) => {
        const masterSoil = masterMshFeatures.find(f => f.properties.id === currentMshCode)?.properties;
        return masterSoil && {
            LEVEL_1: masterSoil?.int_rain_ylw_std_from_sr,
            LEVEL_2: masterSoil?.int_rain_red_std_from_sr,
            LEVEL_3: masterSoil?.soil_rainfall_index,
            LEVEL_4: masterSoil?.int_rain_ppl_std_from_sr,
        };
    };

    useEffect(() => {
        // ローディング開始
        props.setReady(prev => {
            const updated = Object.fromEntries(
                Object.keys(prev).map(key => [key, false])
            );
            return updated;
        });
        const fetchData = async () => {
            let params_obj = {}
            let results = {}
            let consts = {}

            let date_ary = []
            let msh_landslide_risk_all_datetime = []
            let msh_landslide_rain_h1_h24_h48_all_datetime = []
            let bsn_rain_h1_h24_h48_all_datetime = []
            let bsn_info = []

            params_obj = getParamsMsh(props.selectCitys, 'city_code')

            if (Object.keys(params_obj).length > 0) {
                // 日時の配列を取得
                date_ary = getTimeAry(datetimeLatest, props.h6Switch)

                // 6時間モードがONで未来６時間より先の断面を選択されていたら、強制的に未来６時間の断面に補正する
                if (props.h6Switch && chooseNum > 12) {
                    setChooseNum(6)
                }
                //// メッシュコードごとのリスクのオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                // risk_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24]
                // }, ..............]
                msh_landslide_risk_all_datetime = getAllByCode(params_obj.msh_code_ary, mshLandslideData, props.h6Switch)
                //// メッシュコードごとの雨量のオブジェクト配列を取得
                // [{ code: 503021111（メッシュコード）, 
                // h1_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // h24_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // h48_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // }, ..............]
                msh_landslide_rain_h1_h24_h48_all_datetime = getAllByCode(params_obj.msh_code_ary, mshRainData, props.h6Switch)
                //// bsnコードごとのリスクのオブジェクト配列を取得
                // [{ code: 503021111（bsnコード）, 
                // h1_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // h24_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // h48_val: [3, 2, 3, 2, 3, 4, 8, 10, 14, 24],
                // }, ..............]
                bsn_rain_h1_h24_h48_all_datetime = getAllByCode(params_obj.bsn_code_ary, bsnRainData, props.h6Switch)
                bsn_info = getBsnInfo(params_obj.bsn_code_ary, bsnRainData, params_obj.masterBsnFeatures)

                if (bsn_rain_h1_h24_h48_all_datetime.length > 0) {
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H1) {
                        results = getData(msh_landslide_rain_h1_h24_h48_all_datetime,
                            params_obj.masterMshFeatures, params_obj.masterAreaFeatures, 'h1_val')
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H1_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H24) {
                        results = getData(msh_landslide_rain_h1_h24_h48_all_datetime,
                            params_obj.masterMshFeatures, params_obj.masterAreaFeatures, 'h24_val')
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H24_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H48) {
                        results = getData(msh_landslide_rain_h1_h24_h48_all_datetime,
                            params_obj.masterMshFeatures, params_obj.masterAreaFeatures, 'h48_val')
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H48_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_SOIL) {
                        results = getData(msh_landslide_risk_all_datetime,
                            params_obj.masterMshFeatures, params_obj.masterAreaFeatures, 'dc_tank_of_num', true)
                        const SOIL_LEVEL_POINT = get4LinesSoil(params_obj.masterMshFeatures, results.msh_code)
                        consts = getConsts(SOIL_Y_4LINES, SOIL_LEVEL_POINT, true)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_RISK) {
                        results = getData(msh_landslide_risk_all_datetime,
                            params_obj.masterMshFeatures, params_obj.masterAreaFeatures, 'rsk_dc_value_num', true)
                        consts = getConsts(RISK_Y_4LINES, RISK_LEVEL_POINT, true)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H1) {
                        results = getBsnData(bsn_rain_h1_h24_h48_all_datetime, bsn_info, 'h1_val', params_obj.masterBsnFeatures)
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H1_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H24) {
                        results = getBsnData(bsn_rain_h1_h24_h48_all_datetime, bsn_info, 'h24_val', params_obj.masterBsnFeatures)
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H24_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H48) {
                        results = getBsnData(bsn_rain_h1_h24_h48_all_datetime, bsn_info, 'h48_val', params_obj.masterBsnFeatures)
                        consts = getConsts(RAIN_Y_4LINES, RAIN_H48_LEVEL_POINT, false)
                    }
                    if (props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_OF) {
                        results = getBsnData(bsn_rain_h1_h24_h48_all_datetime, bsn_info, 'of_val', params_obj.masterBsnFeatures)
                        consts = getConsts(RISK_Y_4LINES, BSN_RISK_LEVEL_POINT, true)
                    }

                    // １時間雨量の最大値
                    setLandslideH1ValAry(getChoosePointData(msh_landslide_rain_h1_h24_h48_all_datetime, 'h1_val', results.msh_code))
                    // 24時間雨量の最大値
                    setLandslideH24ValAry(getChoosePointData(msh_landslide_rain_h1_h24_h48_all_datetime, 'h24_val', results.msh_code))
                    // 48時間雨量の最大値
                    setLandslideH48ValAry(getChoosePointData(msh_landslide_rain_h1_h24_h48_all_datetime, 'h48_val', results.msh_code))
                    // 土砂リスクの最大値
                    setLandslideRiskValAry(getChoosePointData(msh_landslide_risk_all_datetime, 'soil_index_level', results.msh_code))
                    // 流域平均１時間雨量の最大値
                    setBsnH1ValAry(getChoosePointData(bsn_rain_h1_h24_h48_all_datetime, 'h1_val', results.bsn_code))
                    // 流域平均24時間雨量の最大値
                    setBsnH24ValAry(getChoosePointData(bsn_rain_h1_h24_h48_all_datetime, 'h24_val', results.bsn_code))
                    // 流域平均48時間雨量の最大値
                    setBsnH48ValAry(getChoosePointData(bsn_rain_h1_h24_h48_all_datetime, 'h48_val', results.bsn_code))
                    // 河川リスクの最大値
                    setBsnOfValAry(getChoosePointData(bsn_rain_h1_h24_h48_all_datetime, 'of_val', results.bsn_code))

                    setDateArray(date_ary.length > 0 ? date_ary : null)
                    setAddressWithRiver(results.addressWithRiver)
                    setLevelPoint(consts.point ? consts.point : RAIN_H1_LEVEL_POINT)
                    setBarOrLineAnnotatios(consts.bar_or_line_annotatios ? consts.bar_or_line_annotatios : RAIN_Y_4LINES(RAIN_H1_LEVEL_POINT))
                    setBarOrLineLimitVal(consts.bar_or_line_limit_val ? consts.bar_or_line_limit_val : RAIN_H1_LEVEL_POINT.LEVEL_7 + 10)
                    setMapData(results.map_data?.length > 0 ? results.map_data : null)
                    setChartData(results.chart_data?.length > 0 ? results.chart_data : null)
                    setColorChartData(results.color_chart_data?.length > 0 ? results.color_chart_data : null)
                    setRankData(results.rank_data?.length > 0 ? results.rank_data : null)
                }
            }
        };
        if (datetimeLatest
            && mshRainData
            && bsnRainData
            && mshLandslideData
        ) {
            fetchData();
        }
    }, [datetimeLatest,
        mshRainData,
        bsnRainData,
        mshLandslideData,
        props.selectCitys, props.riskAnalysisLayer, props.h6Switch,
        currentLngLat,
    ]);

    if (datetimeLatestLoading || datetimeLatest === undefined
        || (datetimeLatestError && datetimeLatestError.message.includes("Received HTML"))
        || mshRainLoading || mshRainData === undefined
        || (mshRainError && mshRainError.message.includes("Received HTML"))
        || bsnRainLoading || bsnRainData === undefined
        || (bsnRainError && bsnRainError.message.includes("Received HTML"))
        || (mshLandslideError && mshLandslideError.message.includes("Received HTML"))
        || mshLandslideLoading || mshLandslideData === undefined
        || currentLngLat === null
    ) {
        // Loading表示
        return <Proggress />
    }

    if (datetimeLatestError
        || mshRainError
        || bsnRainError
        || mshLandslideError
        // || bsnRiskError
    ) {
        return (
            <Typography
                sx={{
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    color: 'white',
                }}
            >
                申し訳ございません、データ取得に失敗しました。
                恐れ入りますが、しばらく時間をおいてから再度お試しください。
            </Typography>
        )
    }

    const maxValueCards = (title, POINT, ary, unit, isRisk) => {
        let val = '-'
        let bgColor = RISK_COLOR.OTHER.color
        let fontColor = RISK_COLOR.OTHER.font_color
        if (ary !== null) {
            val = ary[chooseNum]
            if (isRisk) {
                bgColor = setSrRiskColor(val)?.color
                fontColor = setSrRiskColor(val)?.font_color
                val = setSrRiskColor(val)?.label
            } else {
                bgColor = setRainColor(POINT, val)
                fontColor = setRainFontColor(POINT, val)
            }
        }

        return (
            <ColorCard
                child={
                    <Stack>
                        <BoxCenterEnd >
                            <TypographyTitle
                                sx={{ color: fontColor, lineHeight: 1 }}
                            >{val}</TypographyTitle>
                            <TypographyBold14px
                                sx={{ color: fontColor, lineHeight: 1, paddingLeft: '5px' }}
                            >{unit}</TypographyBold14px>
                        </BoxCenterEnd>
                        <BoxFlexEndTop>
                            <TypographyLeftMenu
                                sx={{ color: fontColor, lineHeight: 1 }}
                            >{datetimeLatest[chooseNum]}</TypographyLeftMenu>
                        </BoxFlexEndTop>
                    </Stack>
                }
                title={title}
                bgColor={bgColor}
                fontColor={fontColor}
                xsHeight="25px"
                height="25px"
            />)
    }

    return (
        <>
            <Box
                sx={{
                    // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                    height: { xs: '100%', sm: 'calc(100dvh - 36px - 8px - 8px - 8px)' }, // 親が高さを持つ
                    boxSizing: 'border-box',
                }}
            >
                <HeaderSub
                    pageTitle={""}
                    dateTime={datetimeLatest && datetimeLatest[12]}
                />
                <Grid container
                    spacing={0}
                    columns={12}
                    // height={'100%'}
                    sx={{ height: '100%', width: '100%', padding: 0, m: 0, overflow: 'hidden' }} // Grid全体の高さ100%

                >
                    <Grid size={{ xs: 12, sm: 12, md: 9 }}>
                        {/* <Stack spacing={0} height={{ xs: '100%', sm: 'calc(100dvh - 36px - 17px - 8px - 8px)' }}> */}

                        <Stack >
                            <CommonCard
                                child={
                                    <MapRisk
                                        selectCitys={props.selectCitys}
                                        mapData={mapData}
                                        strDateTimePath={getStrDateTimePath(datetimeLatest[12])}
                                        currentLngLat={currentLngLat}
                                        setCurrentLngLat={setCurrentLngLat}
                                        selectLayer={props.riskAnalysisLayer}
                                        setSelectLayer={props.setRiskAnalysisLayer}
                                        setShouldSelectRankTop={setShouldSelectRankTop}
                                        setReady={props.setReady}
                                        chooseNum={chooseNum}
                                        prefCode={props.prefCode}
                                        setChooseNum={setChooseNum}
                                        dates={props.h6Switch ? datetimeLatest.slice(0, -9) : datetimeLatest}
                                    />
                                }
                                title={addressWithRiver}
                                xsHeight="300px"
                                // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                                // 60dvhなので「* 0.6」している
                                // height='calc(70dvh - (36px * 0.7) - (17px * 0.7) - (8px * 0.7) - (8px * 0.7) - (80px * 0.7) - 31px)'
                                height='calc(70dvh - (36px * 0.7) - (17px * 0.7) - (8px * 0.7) - (8px * 0.7) - 31px)'
                            />

                            {/* Bar、または、Lineグラフ */}
                            <CommonCard
                                child={
                                    <>
                                        {(props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H1
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H24
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H48
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H1
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H24
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H48)
                                            &&
                                            <Bar
                                                annotations={barOrLineAnnotatios}
                                                limitVal={barOrLineLimitVal}
                                                dateArray={dateArray}
                                                chartData={chartData}
                                                isReadyKey={['bar_or_line']}
                                                isReadyFlg={props.isReady.bar_or_line}
                                                setReady={props.setReady}
                                                chooseNum={chooseNum}
                                                dataName={props.riskAnalysisLayer.name}
                                            />
                                        }
                                        {(props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_RISK
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_OF
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_SOIL
                                        )
                                            &&
                                            <Line
                                                annotations={barOrLineAnnotatios}
                                                limitVal={barOrLineLimitVal}
                                                setColor={setColor}
                                                dateArray={dateArray}
                                                chartData={chartData}
                                                colorChartData={colorChartData}
                                                isReadyKey={['bar_or_line']}
                                                isReadyFlg={props.isReady.bar_or_line}
                                                setReady={props.setReady}
                                                chooseNum={chooseNum}
                                                dataName={props.riskAnalysisLayer.name}
                                            />
                                        }
                                    </>
                                }
                                // title={"日時ごとの1時間雨量、避難推奨レベル（土砂）"}
                                xsHeight="200px"
                                // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                                // 30dvhなので「* 0.3」している
                                // height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3) - (80px * 0.3))'
                                height='calc(30dvh - (36px * 0.3) - (17px * 0.3) - (8px * 0.3) - (8px * 0.3))'
                            />

                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 3 }}>
                        <Stack>
                            <Box m={1}>
                                <RiskAnalysisSelectMenus
                                    selectLayer={props.riskAnalysisLayer.category}
                                    setSelectLayer={props.setRiskAnalysisLayer}
                                />
                            </Box>
                            {/* ランキング */}
                            <CommonCard
                                child={
                                    <>
                                        {(props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H1
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H24
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_H48
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H1
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H24
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_H48)
                                            &&
                                            <VerticalBar
                                                distance={10}
                                                limitVal={10}
                                                grid={GRID_RANK}
                                                allRankData={rankData}
                                                dateArray={dateArray}
                                                getRankData={getRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRainColor}
                                                fontSize={'12px'}
                                                getFormat={getFormat}
                                                maxWidth={160}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'100%'}
                                                isReadyKey={['left_rank']}
                                                isReadyFlg={props.isReady.left_rank}
                                                setReady={props.setReady}
                                            />
                                        }
                                        {(props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_RISK
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.BSN_OF
                                            || props.riskAnalysisLayer.category === RISK_ANALYSIS_LAYER_KEY.MSH_SOIL
                                        )
                                            &&
                                            <VerticalBar
                                                distance={10}
                                                limitVal={10}
                                                grid={GRID_RANK}
                                                allRankData={rankData}
                                                dateArray={dateArray}
                                                getRankData={getRankData}
                                                plusValue={10}
                                                verticalBarClickEvent={verticalBarClickEvent}
                                                getRankColor={getRiskColor}
                                                fontSize={'12px'}
                                                getFormat={getFormat}
                                                maxWidth={160}
                                                getLabelFormat={getLabelFormat}
                                                enabled={true}
                                                tooltipFormatX={tooltipFormatX}
                                                tooltipFormatY={tooltipFormatY}
                                                tooltipFormatCustom={tooltipFormatCustom}
                                                height={'100%'}
                                                isReadyKey={['left_rank']}
                                                isReadyFlg={props.isReady.left_rank}
                                                setReady={props.setReady}
                                            />
                                        }
                                    </>
                                }
                                title={"ランキング"}
                                xsHeight="200px"
                                // グローバルヘッダーの「36px」と大枠のGridのマージン上下「8px」ずつを差し引きく
                                // 70dvhなので「* 0.7」している
                                // height='calc(70dvh - (36px * 0.7) - (8px * 0.7) - (8px * 0.7))'
                                height=' calc(100dvh - 36px - 8px - 8px - 17px - 56px - (31px * 4) - (25px * 4) - 31px - (5px * 4))'
                            />
                            {/* リスク・雨量最大値 */}
                            <Grid container columns={12} spacing={1}>

                                <Grid size={{ md: 6 }}>
                                    <Stack spacing={1}>
                                        {maxValueCards('1時間雨量', RAIN_H1_LEVEL_POINT, landslideH1ValAry, 'mm/h', false)}
                                        {maxValueCards('24時間雨量', RAIN_H24_LEVEL_POINT, landslideH24ValAry, 'mm', false)}
                                        {maxValueCards('48時間雨量', RAIN_H48_LEVEL_POINT, landslideH48ValAry, 'mm', false)}
                                        {maxValueCards('土壌雨量指数', TANK_LEVEL_POINT, landslideRiskValAry, '', true)}
                                    </Stack>
                                </Grid>
                                <Grid size={{ md: 6 }}>
                                    <Stack spacing={1}>
                                        {maxValueCards('流域平均1時間雨量', RAIN_H1_LEVEL_POINT, bsnH1ValAry, 'mm/h', false)}
                                        {maxValueCards('流域平均24時間雨量', RAIN_H24_LEVEL_POINT, bsnH24ValAry, 'mm', false)}
                                        {maxValueCards('流域平均48時間雨量', RAIN_H48_LEVEL_POINT, bsnH48ValAry, 'mm', false)}
                                        {maxValueCards('流域平均流出量', BSN_RISK_LEVEL_POINT, bsnOfValAry, '', false)}
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Box >
        </>
    )
}
export default RiskAnalysis;